import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Step3 = ({
  step,
  setStep,
  errors,
  setErrors,
  formData,
  AgentTraits,
  handleCheckboxChange,
  handleInputChange,
}) => {
  const [showCustomHobby, setShowCustomHobby] = useState(false);
  const [customHobbyInput, setCustomHobbyInput] = useState("");

  useEffect(() => {
    // Check if there are any custom hobbies (hobbies not in the predefined list)
    const hasCustomHobbies = formData.hobbies.some(
      (h) => !AgentTraits?.hobbies?.some((hobby) => hobby?.titles?.title === h)
    );

    if (hasCustomHobbies) {
      setShowCustomHobby(true);

      // Get only custom hobbies for the input field
      const customHobbies = formData.hobbies.filter(
        (h) =>
          !AgentTraits?.hobbies?.some((hobby) => hobby?.titles?.title === h)
      );

      setCustomHobbyInput(customHobbies.join(", "));
    }
  }, [formData.hobbies, AgentTraits?.hobbies]);

  const handleNext = (e) => {
    e.preventDefault();
    const stepErrors = validateStep3(formData);
    if (Object.keys(stepErrors).length === 0) {
      setStep(6);
    }
  };
  const validateStep3 = (data) => {
    const newErrors = {};
    if (!data.hobbies || data.hobbies.length === 0) {
      newErrors.hobbies = "At least one hobby is required";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleOtherToggle = () => {
    const newShowCustom = !showCustomHobby;
    setShowCustomHobby(newShowCustom);

    // If unchecking "Other", remove all custom hobbies
    if (!newShowCustom) {
      setCustomHobbyInput("");
      const predefinedHobbies = formData.hobbies.filter((h) =>
        AgentTraits?.hobbies?.some((hobby) => hobby?.titles?.title === h)
      );
      handleInputChange("hobbies", predefinedHobbies);
    }
  };
  const handleCustomHobbyChange = (e) => {
    const inputValue = e.target.value;
    setCustomHobbyInput(inputValue);
  };

  // Handle blur event to process and validate hobbies
  const handleCustomHobbyBlur = () => {
    // Parse comma-separated values
    const customHobbies = customHobbyInput
      .split(",")
      .map((hobby) => hobby.trim())
      .filter((hobby) => hobby.length > 0)
      // Filter out hobbies that already exist in predefined list (case-insensitive)
      .filter(
        (hobby) =>
          !AgentTraits?.hobbies?.some(
            (predefinedHobby) =>
              predefinedHobby?.titles?.title.toLowerCase() ===
              hobby.toLowerCase()
          )
      );

    // Get predefined hobbies (from the checkboxes)
    const predefinedHobbies = formData.hobbies.filter((h) =>
      AgentTraits?.hobbies?.some((hobby) => hobby?.titles?.title === h)
    );

    // Update formData with combined hobbies
    handleInputChange("hobbies", [...predefinedHobbies, ...customHobbies]);

    // Update input to show only valid custom hobbies
    setCustomHobbyInput(customHobbies.join(", "));
  };
  return (
    <>
      <form className="Wrpper d-flex flex-column  gap-4 max-w-[970px]">
        <div className="">
          <div className="head">
            <h5 className="m-0 fw-sbold text-[24px]">Select Hobbies</h5>
          </div>
          <div className="py-3 d-flex flex-column   gap-10 container">
            <RadioList className="list-unstyled row mb-0 ">
              {AgentTraits?.hobbies?.map((val) => {
                return (
                  <li
                    key={val._id}
                    className="position-relative col-md-4 col-6 my-2"
                  >
                    <input
                      name={val?.titles?.title}
                      type="checkbox"
                      checked={formData.hobbies.includes(val?.titles?.title)}
                      onChange={() =>
                        handleCheckboxChange("hobbies", val?.titles?.title)
                      }
                      className="position-absolute peer top-0 left-0 h-100 w-100 z-[99] cursor-pointer opacity-0"
                    />
                    <div
                      className="h-[55px] peer-checked:bg-[#4A2CE5] peer-checked:text-white peer-checked:border-[#4A2CE5] d-flex align-items-center  justify-content-center  rounded-pill px-3 py-2 min-w-[162px] border border-[#868686]/30 fw-sbold"
                      style={{ fontSize: 12 }}
                    >
                      {val?.titles?.title}
                    </div>
                  </li>
                );
              })}
              <li className="position-relative col-md-4 col-6 my-2">
                <input
                  type="checkbox"
                  id="hobby-other"
                  name="Other"
                  checked={showCustomHobby}
                  onChange={handleOtherToggle}
                  className="position-absolute peer top-0 left-0 h-100 w-100 z-[99] cursor-pointer opacity-0"
                />
                <div className="h-[55px] peer-checked:bg-[#4A2CE5] peer-checked:text-white peer-checked:border-[#4A2CE5] d-flex align-items-center  justify-content-center  rounded-pill px-3 py-2 min-w-[162px] border border-[#868686]/30 fw-sbold">
                  Other
                </div>
              </li>
            </RadioList>
            {showCustomHobby && (
              <div className="mt-4">
                <label
                  htmlFor="custom-hobby"
                  className="form-label m-0 pb-1 d-block"
                >
                  Enter Custom Hobbies
                </label>
                <input
                  type="text"
                  id="custom-hobby"
                  placeholder="e.g., Painting, Rock Climbing, Photography"
                  className="form-control"
                  value={customHobbyInput}
                  onChange={handleCustomHobbyChange}
                  onBlur={handleCustomHobbyBlur}
                />
                <div className="text-[13px] text-gray-500 mt-1">
                  Note: Hobbies already in the list above will be automatically
                  excluded
                </div>
              </div>
            )}

            {errors.hobbies && (
              <div className="text-danger text-sm mt-2">{errors.hobbies}</div>
            )}
          </div>
        </div>
        <div className="mt-10 mx-auto w-100" style={{ maxWidth: 300 }}>
          <button
            onClick={handleNext}
            className="d-flex align-items-center  justify-content-center  bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill max-w-[377px] mx-auto transition-colors  w-100"
          >
            Next
          </button>
          <button
            onClick={() => setStep(2)}
            className="d-flex align-items-center  justify-content-center  bg-blue-600 hover:bg-blue-700 text-white h-[40px] commonBtn btn rounded-pill
             max-w-[377px] mx-auto transition-colors gap -2 mt-3 w-100"
            type="button"
          >
            Back
          </button>
        </div>
      </form>
    </>
  );
};

const RadioList = styled.ul`
  li {
    input {
      cursor: pointer;
      z-index: 99;
    }
    input:checked + div {
      border-color: #9701ea !important;
      background: #9701ea;
      color: #fff;
    }
  }
`;

export default Step3;

const fileIcn = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="22" fill="#4A2CE5" />
    <path
      d="M18.9995 27.7505C18.5895 27.7505 18.2495 27.4105 18.2495 27.0005V22.8105L17.5295 23.5305C17.2395 23.8205 16.7595 23.8205 16.4695 23.5305C16.1795 23.2405 16.1795 22.7605 16.4695 22.4705L18.4695 20.4705C18.6795 20.2605 19.0095 20.1905 19.2895 20.3105C19.5695 20.4205 19.7495 20.7005 19.7495 21.0005V27.0005C19.7495 27.4105 19.4095 27.7505 18.9995 27.7505Z"
      fill="white"
    />
    <path
      d="M20.9995 23.7495C20.8095 23.7495 20.6195 23.6795 20.4695 23.5295L18.4695 21.5295C18.1795 21.2395 18.1795 20.7595 18.4695 20.4695C18.7595 20.1795 19.2395 20.1795 19.5295 20.4695L21.5295 22.4695C21.8195 22.7595 21.8195 23.2395 21.5295 23.5295C21.3795 23.6795 21.1895 23.7495 20.9995 23.7495Z"
      fill="white"
    />
    <path
      d="M25 32.75H19C13.57 32.75 11.25 30.43 11.25 25V19C11.25 13.57 13.57 11.25 19 11.25H24C24.41 11.25 24.75 11.59 24.75 12C24.75 12.41 24.41 12.75 24 12.75H19C14.39 12.75 12.75 14.39 12.75 19V25C12.75 29.61 14.39 31.25 19 31.25H25C29.61 31.25 31.25 29.61 31.25 25V20C31.25 19.59 31.59 19.25 32 19.25C32.41 19.25 32.75 19.59 32.75 20V25C32.75 30.43 30.43 32.75 25 32.75Z"
      fill="white"
    />
    <path
      d="M32 20.7505H28C24.58 20.7505 23.25 19.4205 23.25 16.0005V12.0005C23.25 11.7005 23.43 11.4205 23.71 11.3105C23.99 11.1905 24.31 11.2605 24.53 11.4705L32.53 19.4705C32.74 19.6805 32.81 20.0105 32.69 20.2905C32.57 20.5705 32.3 20.7505 32 20.7505ZM24.75 13.8105V16.0005C24.75 18.5805 25.42 19.2505 28 19.2505H30.19L24.75 13.8105Z"
      fill="white"
    />
  </svg>
);
